export const Jobs: Array<string> = ["bartender", "software_engineer"];
